@import '~@s-ui/theme/lib/index';
@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-icon/lib/index';
@import '~@s-ui/react-atom-image/lib/index';
@import '~@s-ui/react-atom-tooltip/lib/index';
@import '~@s-ui/react-primitive-typography/lib/index';
@import '~@s-ui/react-molecule-notification/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-net-drawer/lib/index';
@import '~@adv-mt/mt-net-message-list/lib/index';
@import '~@adv-mt/mt-net-input/lib/index';
@import '~@adv-mt/mt-net-suggestions/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@adv-mt/mt-net-feedback/lib/index';
@import '~@adv-mt/mt-notifications-ad-favorite/lib/index';
@import '~@adv-mt/mt-form-contact-seller/lib/index';

$base-class: '.mt-Net';

$w-net-drawer: 400px;
$w-net-sidebar: 300px;
$w-net-drawer-collapsed: 80px;
$mw-net-page: 960px;
$mw-net-input: 790px;
$mw-net-chat: 790px;
$mw-net-suggestions: 650px;
$h-net-logo: 26px;
$w-net-logo: 160px;
$bd-net-gradient: linear-gradient(90deg, #e60e27 0%, #4c57ff 50%, #000e23 100%);

.mt-Net {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: $mw-net-page;
  min-height: 100dvh;
  width: 100%;

  &-header {
    align-items: center;
    background-color: $c-white;
    display: flex;
    justify-content: space-between;
    padding: $p-xl $p-l $p-l;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 4;

    &Logo {
      height: $h-net-logo !important;
      width: $w-net-logo !important;
      opacity: 1;
      transition: opacity 200ms ease-in-out;

      &--hidden {
        opacity: 0;
      }
    }

    &Actions {
      align-items: center;
      display: flex;
      gap: $m-m;
    }
  }

  &-welcome {
    align-items: flex-start;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    padding: 0 $p-l;

    &Text {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      gap: $g-m;
    }

    &Headline {
      background: $bd-net-gradient;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &Suggestions {
      margin: 0 auto;
      max-width: $mw-net-suggestions;
      padding-top: $p-xxl;
      width: 100%;
    }
  }

  &-chat {
    animation: net-chat-enter 0.3s ease-out;
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: 0 auto;
    max-width: $mw-net-chat;
    min-height: 0;
    overflow: hidden;
    width: 100%;
  }

  &-bottom {
    align-items: center;
    background-color: $c-white;
    bottom: 0;
    display: flex;
    flex-direction: column;
    position: sticky;
    width: 100%;
    z-index: 4;
  }

  &-footer {
    background-color: $c-white;
    display: flex;
    flex-direction: column;
    gap: $g-l;
    padding: $p-l;
    text-align: center;
  }

  &-terms {
    color: $c-primary-dim1;

    &-link {
      color: $c-primary-dim1;
      font-weight: $fw-semi-bold;
      text-decoration: underline;
    }
  }

  &-newChatDrawer {
    &-title {
      margin-bottom: $m-l;
    }

    &-content {
      display: flex;
      flex-direction: column;
      padding: $p-l;
    }

    &-footer {
      padding: $p-l;
    }
  }

  &-reviewDrawer {
    &-content {
      height: 100%;
    }
  }

  &-contactAdDrawer {
    &-content {
      padding: $p-l;
    }
  }

  &-contactAdDrawer,
  &-newChatDrawer,
  &-reviewDrawer {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-width: $w-net-drawer;

    &-header {
      align-items: center;
      display: flex;
      justify-content: space-between;
      padding: $p-l $p-l 0 $p-l;
    }

    &-footer {
      display: flex;
      flex-direction: column;
      gap: $g-l;
      margin-top: auto;
    }
  }

  &-chatsSidebar {
    height: 100%;

    &-collapsed {
      align-items: center;
      border-right: $bdw-s solid $c-primary-container;
      display: flex;
      flex-direction: column;
      gap: $m-xxl;
      height: 100%;
      left: 0;
      max-width: $w-net-drawer-collapsed;
      padding: $p-l;
      position: fixed;
      top: 0;
      z-index: 1;
    }

    @include media-breakpoint-up(m) {
      .sui-MoleculeDrawer-content--size-m.sui-MoleculeDrawer-content--placement-left {
        width: $w-net-sidebar;
      }

      .sui-MoleculeDrawer-content--state-opened {
        border-right: $bdw-s solid $c-primary-container;
        box-shadow: none;
      }
    }

    &-expanded {
      display: flex;
      flex-direction: column;
      gap: $p-l;
      height: 100%;
    }

    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: $g-m;
      padding: $p-l $p-l 0 $p-l;

      &Logo {
        height: $h-net-logo !important;
        width: $w-net-logo !important;
      }

      &Mobile {
        justify-content: flex-start;
      }

      &CloseIcon {
        margin-left: auto;
      }
    }
  }

  &-notification {
    bottom: 0;
    padding: $p-l;
    position: fixed;
    right: 0;
    width: 100%;
    z-index: $z-notification;
  }

  &--welcome,
  &--conversation {
    #{$base-class}-input {
      max-width: $mw-net-input;
      padding: $p-l $p-l 0 $p-l;
      width: 100%;
    }
  }

  &--welcome {
    @include media-breakpoint-up(m) {
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      grid-template-rows: auto 1fr repeat(3, auto) 1fr auto;

      #{$base-class}-welcome,
      #{$base-class}-bottom {
        display: contents;
      }

      #{$base-class}-welcomeText {
        align-items: center;
        grid-row: 3;
      }

      #{$base-class}-input {
        grid-row: 4;
        justify-self: center;
        max-width: $mw-net-input;
        padding: $p-xxl 0 0;
        width: 100%;
      }

      #{$base-class}-welcomeSuggestions {
        grid-row: 5;
        padding-top: $p-giant;
      }

      #{$base-class}-footer {
        grid-row: 7;
      }
    }
  }

  @keyframes net-chat-enter {
    from {
      opacity: 0;
      transform: translateY(16px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
